import { IContentExclusion } from '../../../../interfaces/creation-form';
import { getContentExclusionTypeLabel } from '../../../../enums/content-exclusion-type';

const getContentExclusionSearchableText = (exclusion: IContentExclusion): string =>
    [
        exclusion.sport,
        exclusion.competition,
        exclusion.dataProvider,
        getContentExclusionTypeLabel(exclusion.type),
    ]
        .join(' ')
        .toLowerCase();

export const contentExclusionMatchesSearch = (
    exclusion: IContentExclusion,
    normalizedSearchQuery: string
): boolean => getContentExclusionSearchableText(exclusion).includes(normalizedSearchQuery);
